exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".post-content-link{display:inline-block;cursor:pointer;font-weight:300;line-height:normal}", ""]);

